export default "__VITE_ASSET__BIdep3qL__"